import React from 'react'
import getConfig from 'next/config';
import styles from './Footer.scss'
import {CARS_NAV, HEALTH_NAV, BRANDS_NAV} from '../../../components/Navigation/navs'

const Footer = () => {
  const build_navigation = (obj) => {
    return (
      <>
        <p className='section-title'>
          <strong>{obj[0].title}</strong>
        </p>

        <ul className='footer-navigation'>
          {obj[0].childItems.map((item, index, row) => (
            <li
              key={index}
              className={`${(index + 1 === row.length) ? 'mb-1000' : 'mb-0500'}`}
            >
              <a
                href={item.link}
                title={item.title}
              >
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      </>
    )
  }

  return (
    <footer className="main-footer">
      <section className="section products">
        <div className="container">
          <div className="row">
            <div className="col">
              {build_navigation(CARS_NAV)}
            </div>

            <div className="col">
              {build_navigation(HEALTH_NAV)}
            </div>

            <div className="col">
              {build_navigation(BRANDS_NAV)}
            </div>
          </div>
        </div>
      </section>

      <section className='section info'>
        <div className="container">
          <div className="row">
            <div className="col info-col-one">
              <img
                src='/static/images/lifepal-logo-blue-svg.svg'
                alt='Lifepal'
                className='mb-0250'
                width={160}
                height={55}
                loading='lazy'
                fetchPriority='low'
              />

              <p className='mb-1500'>
                <strong>PT Abisatya Pialang Asuransi</strong>
              </p>

              <p className='font-size-1500 mb-0500'>
                <strong>
                  Marketplace Asuransi Terbaik di Indonesia
                </strong>
              </p>

              <p className='font-size-0875 mb-1500'>
                Beneran Pilihannya, Beneran Hematnya.
              </p>

              <p className='section-title'>
                <strong>Alamat</strong>
              </p>

              <p className='font-size-0875 mb-0750'>
                CIBIS 9 17th Floor jl TB Simatupang No.2 Cilandak Timur, Pasar Minggu Jakarta Selatan 12560
              </p>

              <a
                href='https://www.google.com/maps/@-6.2948158,106.8153824,19z'
                className='btn icon gradient-primary-blue-20 mb-2000'
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 21" fill="none"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path className='fill' fillRule="evenodd" clipRule="evenodd" d="M14.13 6.01733C11.8493 3.73668 8.15136 3.73668 5.8707 6.01733C3.59047 8.29756 3.59047 11.9942 5.8707 14.2745L9.41654 17.8203C9.73911 18.1429 10.2615 18.143 10.5846 17.8199L14.13 14.2745C16.4102 11.9942 16.4102 8.29756 14.13 6.01733ZM4.70191 4.84636C7.62824 1.92003 12.3725 1.92003 15.2988 4.84636C18.2256 7.77313 18.2256 12.5187 15.2988 15.4454L13.7748 16.9694C13.7314 17.0129 13.8032 16.941 13.7598 16.9845L12.3862 18.358C12.3387 18.4055 12.4188 18.3254 12.3714 18.3728L11.7534 18.9908C10.7851 19.9591 9.21654 19.9601 8.24774 18.9913L4.70191 15.4454C1.77515 12.5187 1.77515 7.77313 4.70191 4.84636ZM10.0004 8.47351C9.07557 8.47351 8.3272 9.22299 8.3272 10.1459C8.3272 11.0688 9.07557 11.8183 10.0004 11.8183C10.9251 11.8183 11.6735 11.0688 11.6735 10.1459C11.6735 9.22299 10.9251 8.47351 10.0004 8.47351ZM6.6735 10.1459C6.6735 8.30738 8.16371 6.81828 10.0004 6.81828C11.837 6.81828 13.3272 8.30738 13.3272 10.1459C13.3272 11.9844 11.837 13.4735 10.0004 13.4735C8.16371 13.4735 6.6735 11.9844 6.6735 10.1459Z" />
                </svg>

                Google Maps
              </a>
              
              <div className="mb-2000">
                <p className='font-size-0875 mb-0250'>
                  Berizin dan diawasi OJK
                </p>
                
                <img
                  src='/static/images/logo/ojk.svg'
                  alt='OJK'
                  width={102}
                  height={41}
                  loading='lazy'  />
              </div>
            </div>

            <div className="col info-col-two">
              <p className="section-title">
                <strong>Layanan Customer Support</strong>
              </p>

              <div className="cs-box mb-2000">
                <div className="cs-box-row">
                  <div className="cs-box-col d-lg-flex flex-gap-1000">
                    <div>
                      <p className='font-size-0875 mb-0375'>WA (Chat only)</p>

                      <a
                        className="btn icon secondary-green-070 mb-1000"
                        href='https://api.whatsapp.com/send/?phone=6282330030027&text=Halo%20Lifepal%2C%20saya%20memiliki%20pertanyaan%20tentang%20produk%20asuransi'
                      >
                        <svg
                          className="fill"
                          xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path fillRule="evenodd" clipRule="evenodd" d="M13.3145 2.41833C11.9044 1.00663 10.0292 0.228846 8.0313 0.228027C3.91472 0.228027 0.564241 3.57823 0.562635 7.69609C0.562059 9.01245 0.905974 10.2973 1.55958 11.4299L0.5 15.3001L4.45924 14.2615C5.5501 14.8565 6.77833 15.1701 8.02833 15.1705H8.03136C8.03112 15.1705 8.0316 15.1705 8.03136 15.1705C12.1475 15.1705 15.4983 11.82 15.5 7.70206C15.5007 5.70642 14.7246 3.82998 13.3145 2.41833ZM8.03133 13.9092H8.02882C6.91497 13.9088 5.82244 13.6095 4.86934 13.0439L4.64269 12.9094L2.29322 13.5257L2.92035 11.235L2.77274 11.0001C2.15136 10.0118 1.82318 8.86944 1.82367 7.69651C1.825 4.27391 4.60979 1.48942 8.03385 1.48942C9.69188 1.48994 11.2505 2.13651 12.4225 3.30986C13.5945 4.48322 14.2396 6.04288 14.2389 7.70155C14.2375 11.1244 11.4528 13.9092 8.03133 13.9092Z" />
                          
                          <path fillRule="evenodd" clipRule="evenodd" d="M11.4363 9.25973C11.2497 9.16632 10.3322 8.71494 10.1612 8.6526C9.99012 8.59033 9.8657 8.5592 9.74131 8.74601C9.61692 8.93279 9.25927 9.35317 9.1504 9.47774C9.04156 9.60222 8.93266 9.6179 8.74609 9.5244C8.55949 9.43099 7.95819 9.23396 7.2454 8.59819C6.6906 8.10332 6.3161 7.49225 6.2072 7.30538C6.09836 7.1186 6.19562 7.01761 6.28906 6.92454C6.373 6.84089 6.47569 6.70659 6.569 6.5976C6.66229 6.48867 6.69339 6.41076 6.7556 6.28631C6.81781 6.16173 6.78674 6.05275 6.74005 5.95937C6.69339 5.86596 6.32019 4.94742 6.1647 4.5737C6.01317 4.20987 5.85934 4.25916 5.74478 4.25337C5.63609 4.24795 5.51152 4.24683 5.38713 4.24683C5.26274 4.24683 5.06052 4.29354 4.88951 4.48033C4.71846 4.66717 4.23633 5.11868 4.23633 6.03713C4.23633 6.9557 4.90503 7.84308 4.99834 7.96759C5.09163 8.0922 6.31425 9.97706 8.18626 10.7854C8.63149 10.9777 8.97911 11.0925 9.25011 11.1785C9.69716 11.3206 10.104 11.3005 10.4255 11.2524C10.7841 11.1989 11.5296 10.801 11.6851 10.3651C11.8407 9.92919 11.8407 9.5555 11.794 9.47771C11.7473 9.39989 11.6229 9.35317 11.4363 9.25973Z" />
                        </svg>

                        0823 300 300 27
                      </a>
                    </div>
                    
                    <div>
                      <p className='font-size-0875 mb-0375'>Email</p>

                      <a
                        className="btn icon gradient-primary-blue-20 mb-1000"
                        href="mailto:support@lifepal.co.id"
                      >
                        <svg
                          className="stroke"
                          xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path d="M2.5 6.66675L9.0755 11.0504C9.63533 11.4236 10.3647 11.4236 10.9245 11.0504L17.5 6.66675M4.16667 15.8334H15.8333C16.7538 15.8334 17.5 15.0872 17.5 14.1667V5.83341C17.5 4.91294 16.7538 4.16675 15.8333 4.16675H4.16667C3.24619 4.16675 2.5 4.91294 2.5 5.83341V14.1667C2.5 15.0872 3.24619 15.8334 4.16667 15.8334Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>

                        Support@lifepal.co.id
                      </a>
                    </div>
                  </div>
                </div>

                <hr className='mb-1000' />

                <div className="cs-box-row">
                  <div className="cs-box-col">
                    <p className='font-size-0875 mb-0375'>Penawaran dan<br />Pembelian</p>

                    <a
                      className="btn icon gradient-primary-blue-060 mb-1000"
                      href='tel:02130762306'
                    >
                      <svg
                        className="stroke"
                        xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path d="M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H6.89937C7.25806 2.5 7.57651 2.72953 7.68994 3.06981L8.93811 6.81434C9.06926 7.20777 8.89115 7.63776 8.52022 7.82322L6.63917 8.76375C7.55771 10.801 9.19898 12.4423 11.2363 13.3608L12.1768 11.4798C12.3622 11.1088 12.7922 10.9307 13.1857 11.0619L16.9302 12.3101C17.2705 12.4235 17.5 12.7419 17.5 13.1006V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H15C8.09644 17.5 2.5 11.9036 2.5 5V4.16667Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>

                      021 3076 2306
                    </a>

                    <p className='font-size-0875 mb-0375'>Perpanjangan Polis</p>

                    <a
                      className="btn icon gradient-primary-blue-060 mb-1000"
                      href='tel:02130762308'
                    >
                      <svg
                        className="stroke"
                        xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path d="M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H6.89937C7.25806 2.5 7.57651 2.72953 7.68994 3.06981L8.93811 6.81434C9.06926 7.20777 8.89115 7.63776 8.52022 7.82322L6.63917 8.76375C7.55771 10.801 9.19898 12.4423 11.2363 13.3608L12.1768 11.4798C12.3622 11.1088 12.7922 10.9307 13.1857 11.0619L16.9302 12.3101C17.2705 12.4235 17.5 12.7419 17.5 13.1006V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H15C8.09644 17.5 2.5 11.9036 2.5 5V4.16667Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>

                      021 3076 2308
                    </a>
                  </div>

                  <div className="cs-box-col">
                    <p className='font-size-0875 mb-0375'>Waktu Operasional</p>

                    <div className='font-size-0875 mb-0500 waktu-operasional'>
                      Senin - Jumat
                      <br />
                      <strong>08:00 - 19:00 WIB</strong>
                    </div>

                    <div className='font-size-0875 mb-0500 waktu-operasional'>
                      Sabtu
                      <br />
                      <strong>08:00 - 17:00 WIB</strong>
                    </div>

                    <div className='font-size-0875 mb-0500 waktu-operasional'>
                      Minggu dan Hari Libur Nasional
                      <br />
                      <strong>Tutup</strong>
                    </div>
                  </div>
                </div>

                <hr className='border-width-1px border-bottom-dashed border-color-secondary-neutral-040 mb-1000' />

                <div className="cs-box-row">
                  <div className="cs-box-col">
                    <p className='font-size-0875 mb-0375'>Customer Service</p>

                    <a
                      className="btn icon gradient-primary-blue-060 mb-1000"
                      href='tel:02130762309'
                    >
                      <svg
                        className="stroke"
                        xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path d="M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H6.89937C7.25806 2.5 7.57651 2.72953 7.68994 3.06981L8.93811 6.81434C9.06926 7.20777 8.89115 7.63776 8.52022 7.82322L6.63917 8.76375C7.55771 10.801 9.19898 12.4423 11.2363 13.3608L12.1768 11.4798C12.3622 11.1088 12.7922 10.9307 13.1857 11.0619L16.9302 12.3101C17.2705 12.4235 17.5 12.7419 17.5 13.1006V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H15C8.09644 17.5 2.5 11.9036 2.5 5V4.16667Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>

                      021 3076 2309
                    </a>
                  </div>

                  <div className="cs-box-col">
                    <p className='font-size-0875 mb-0375'>Waktu Operasional</p>

                    <div className='font-size-0875 mb-0500 waktu-operasional'>
                      Senin - Jumat
                      <br />
                      <strong>08:00 - 18:00 WIB</strong>
                    </div>

                    <div className='font-size-0875 mb-0500 waktu-operasional'>
                      Sabtu, Minggu dan Hari Libur Nasional
                      <br />
                      <strong>Tutup</strong>
                    </div>
                  </div>
                </div>
              </div>

              <p className='section-title'>
                <strong>Social Media</strong>
              </p>

              <div className='d-flex flex-wrap flex-gap-0750 mb-2000'>
                <a
                  href='https://www.facebook.com/lifepal'
                  className='btn icon gradient-primary-blue-20 font-size-0875'
                >
                  <svg className='fill stroke' xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"
                  aria-hidden="true"
                  focusable="false"
                  >
                    <path d="M4.88379 0.5H6.2666V2.06641H4.88379C4.75028 2.06641 4.61749 2.09344 4.49414 2.14453C4.3709 2.19562 4.2584 2.26992 4.16406 2.36426C4.06971 2.45863 3.99541 2.57105 3.94434 2.69434C3.89329 2.81758 3.86625 2.94961 3.86621 3.08301V5.2998H6.14941L5.75781 6.86621H3.86621V11.667H2.2998V6.86621H0.5V5.2998H2.2998V3.08301C2.29989 2.39803 2.57231 1.74122 3.05664 1.25684C3.48053 0.832944 4.03657 0.571429 4.62793 0.512695L4.88379 0.5Z" />
                </svg>
                    
                  Facebook
                </a>

                <a
                  href='https://www.instagram.com/lifepal'
                  className='btn icon gradient-primary-blue-20 font-size-0875'
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path className='fill' d="M6.99945 3.53223C5.11773 3.53223 3.55859 5.06448 3.55859 6.97309C3.55859 8.88169 5.09085 10.4139 6.99945 10.4139C8.90806 10.4139 10.4403 8.85481 10.4403 6.97309C10.4403 5.09137 8.88118 3.53223 6.99945 3.53223ZM6.99945 9.17739C5.78978 9.17739 4.79515 8.18276 4.79515 6.97309C4.79515 5.76341 5.78978 4.76879 6.99945 4.76879C8.20913 4.76879 9.20376 5.76341 9.20376 6.97309C9.20376 8.18276 8.20913 9.17739 6.99945 9.17739Z" />

                    <path className='fill' d="M10.5755 4.23126C11.006 4.23126 11.355 3.88223 11.355 3.45169C11.355 3.02114 11.006 2.67212 10.5755 2.67212C10.1449 2.67212 9.7959 3.02114 9.7959 3.45169C9.7959 3.88223 10.1449 4.23126 10.5755 4.23126Z" />

                    <path className='fill' d="M12.5911 1.4354C11.8921 0.709596 10.8975 0.333252 9.76849 0.333252H4.23086C1.89215 0.333252 0.333008 1.89239 0.333008 4.2311V9.74185C0.333008 10.8978 0.709352 11.8924 1.46204 12.6182C2.18785 13.3171 3.15559 13.6666 4.25774 13.6666H9.74161C10.8975 13.6666 11.8653 13.2902 12.5642 12.6182C13.29 11.9193 13.6663 10.9247 13.6663 9.76874V4.2311C13.6663 3.10207 13.29 2.13433 12.5911 1.4354ZM12.4835 9.76874C12.4835 10.6021 12.1878 11.2741 11.704 11.7311C11.2201 12.1881 10.5481 12.43 9.74161 12.43H4.25774C3.45129 12.43 2.77924 12.1881 2.29537 11.7311C1.8115 11.2472 1.56957 10.5752 1.56957 9.74185V4.2311C1.56957 3.42465 1.8115 2.75261 2.29537 2.26874C2.75236 1.81175 3.45129 1.56981 4.25774 1.56981H9.79537C10.6018 1.56981 11.2739 1.81175 11.7577 2.29562C12.2147 2.77949 12.4835 3.45153 12.4835 4.2311V9.76874Z" />
                  </svg>

                  Instagram
                </a>

                <a
                  href='https://www.youtube.com/channel/UC-14O1IUXJ_m5t8PRAfWm5w'
                  className='btn icon gradient-primary-blue-20 font-size-0875'
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path className='fill' d="M6.66671 10.794L10.1267 8.79399L6.66671 6.79399V10.794ZM14.3734 5.57399C14.46 5.88732 14.52 6.30732 14.56 6.84065C14.6067 7.37399 14.6267 7.83399 14.6267 8.23399L14.6667 8.79399C14.6667 10.254 14.56 11.3273 14.3734 12.014C14.2067 12.614 13.82 13.0007 13.22 13.1673C12.9067 13.254 12.3334 13.314 11.4534 13.354C10.5867 13.4007 9.79337 13.4207 9.06004 13.4207L8.00004 13.4607C5.20671 13.4607 3.46671 13.354 2.78004 13.1673C2.18004 13.0007 1.79337 12.614 1.62671 12.014C1.54004 11.7007 1.48004 11.2807 1.44004 10.7473C1.39337 10.214 1.37337 9.75399 1.37337 9.35399L1.33337 8.79399C1.33337 7.33399 1.44004 6.26065 1.62671 5.57399C1.79337 4.97399 2.18004 4.58732 2.78004 4.42065C3.09337 4.33399 3.66671 4.27399 4.54671 4.23399C5.41337 4.18732 6.20671 4.16732 6.94004 4.16732L8.00004 4.12732C10.7934 4.12732 12.5334 4.23399 13.22 4.42065C13.82 4.58732 14.2067 4.97399 14.3734 5.57399Z" />
                  </svg>
                    
                  Youtube
                </a>

                <a
                  href='https://www.tiktok.com/@lifepal.co.id?lang=en'
                  className='btn icon gradient-primary-blue-20 font-size-0875'
                >
                  <svg className='fill' xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M8.40321 0.0149998C9.40844 0 10.406 0.00749991 11.4036 0C11.4649 1.14749 11.887 2.31747 12.7464 3.12746C13.6059 3.95995 14.8183 4.34245 16 4.46994V7.49241C14.895 7.45491 13.7824 7.22991 12.7771 6.76492C12.3397 6.56992 11.933 6.32242 11.534 6.06742C11.5263 8.2574 11.5417 10.4474 11.5187 12.6298C11.4573 13.6798 11.1043 14.7223 10.4827 15.5848C9.4775 17.0248 7.73561 17.9623 5.94768 17.9923C4.85036 18.0523 3.75305 17.7598 2.81688 17.2198C1.26682 16.3273 0.177183 14.6923 0.016039 12.9373C0.000691917 12.5623 -0.0069816 12.1873 0.00836545 11.8199C0.146489 10.3949 0.867801 9.02989 1.98814 8.0999C3.26194 7.01991 5.0422 6.50242 6.70736 6.80991C6.7227 7.9199 6.67666 9.02989 6.67666 10.1399C5.91698 9.89988 5.02685 9.96737 4.35926 10.4174C3.87582 10.7249 3.50749 11.1974 3.31566 11.7299C3.15451 12.1123 3.20055 12.5323 3.20823 12.9373C3.39239 14.1673 4.60481 15.2023 5.89396 15.0898C6.7534 15.0823 7.57446 14.5948 8.01953 13.8823C8.16533 13.6348 8.32647 13.3798 8.33414 13.0873C8.41088 11.7449 8.38019 10.4099 8.38786 9.06739C8.39553 6.04492 8.38019 3.02996 8.40321 0.0149998Z"/>
                  </svg>
                    
                  Tiktok
                </a>

                <a
                  href='https://www.linkedin.com/company/lifepalcoid/'
                  className='btn icon gradient-primary-blue-20 font-size-0875'
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path className='fill' d="M12.6667 2C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667ZM12.3333 12.3333V8.8C12.3333 8.2236 12.1044 7.6708 11.6968 7.26322C11.2892 6.85564 10.7364 6.62667 10.16 6.62667C9.59333 6.62667 8.93333 6.97333 8.61333 7.49333V6.75333H6.75333V12.3333H8.61333V9.04667C8.61333 8.53333 9.02667 8.11333 9.54 8.11333C9.78754 8.11333 10.0249 8.21167 10.2 8.3867C10.375 8.56173 10.4733 8.79913 10.4733 9.04667V12.3333H12.3333ZM4.58667 5.70667C4.88371 5.70667 5.16859 5.58867 5.37863 5.37863C5.58867 5.16859 5.70667 4.88371 5.70667 4.58667C5.70667 3.96667 5.20667 3.46 4.58667 3.46C4.28786 3.46 4.00128 3.5787 3.78999 3.78999C3.5787 4.00128 3.46 4.28786 3.46 4.58667C3.46 5.20667 3.96667 5.70667 4.58667 5.70667ZM5.51333 12.3333V6.75333H3.66667V12.3333H5.51333Z" />
                  </svg>

                  Linkedin
                </a>
              </div>
            </div>

            <div className="col info-col-three">
              <p className='section-title'>
                <strong>Layanan Pengaduan Konsumen</strong>
              </p>

              <p className='font-size-0875'>Direktorat Jenderal Perlindungan Konsumen dan Tertib Niaga, Kementerian Perdagangan Republik Indonesia.</p>

              <a
                href='https://api.whatsapp.com/send/?phone=628531111101'
                className='btn icon gradient-primary-blue-20 font-size-0875 mb-2000'
              >
                <svg
                  className='fill'
                  xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path fillRule="evenodd" clipRule="evenodd" d="M13.3145 2.41833C11.9044 1.00663 10.0292 0.228846 8.0313 0.228027C3.91472 0.228027 0.564241 3.57823 0.562635 7.69609C0.562059 9.01245 0.905974 10.2973 1.55958 11.4299L0.5 15.3001L4.45924 14.2615C5.5501 14.8565 6.77833 15.1701 8.02833 15.1705H8.03136C8.03112 15.1705 8.0316 15.1705 8.03136 15.1705C12.1475 15.1705 15.4983 11.82 15.5 7.70206C15.5007 5.70642 14.7246 3.82998 13.3145 2.41833ZM8.03133 13.9092H8.02882C6.91497 13.9088 5.82244 13.6095 4.86934 13.0439L4.64269 12.9094L2.29322 13.5257L2.92035 11.235L2.77274 11.0001C2.15136 10.0118 1.82318 8.86944 1.82367 7.69651C1.825 4.27391 4.60979 1.48942 8.03385 1.48942C9.69188 1.48994 11.2505 2.13651 12.4225 3.30986C13.5945 4.48322 14.2396 6.04288 14.2389 7.70155C14.2375 11.1244 11.4528 13.9092 8.03133 13.9092Z" />
                  
                  <path fillRule="evenodd" clipRule="evenodd" d="M11.4363 9.25973C11.2497 9.16632 10.3322 8.71494 10.1612 8.6526C9.99012 8.59033 9.8657 8.5592 9.74131 8.74601C9.61692 8.93279 9.25927 9.35317 9.1504 9.47774C9.04156 9.60222 8.93266 9.6179 8.74609 9.5244C8.55949 9.43099 7.95819 9.23396 7.2454 8.59819C6.6906 8.10332 6.3161 7.49225 6.2072 7.30538C6.09836 7.1186 6.19562 7.01761 6.28906 6.92454C6.373 6.84089 6.47569 6.70659 6.569 6.5976C6.66229 6.48867 6.69339 6.41076 6.7556 6.28631C6.81781 6.16173 6.78674 6.05275 6.74005 5.95937C6.69339 5.86596 6.32019 4.94742 6.1647 4.5737C6.01317 4.20987 5.85934 4.25916 5.74478 4.25337C5.63609 4.24795 5.51152 4.24683 5.38713 4.24683C5.26274 4.24683 5.06052 4.29354 4.88951 4.48033C4.71846 4.66717 4.23633 5.11868 4.23633 6.03713C4.23633 6.9557 4.90503 7.84308 4.99834 7.96759C5.09163 8.0922 6.31425 9.97706 8.18626 10.7854C8.63149 10.9777 8.97911 11.0925 9.25011 11.1785C9.69716 11.3206 10.104 11.3005 10.4255 11.2524C10.7841 11.1989 11.5296 10.801 11.6851 10.3651C11.8407 9.92919 11.8407 9.5555 11.794 9.47771C11.7473 9.39989 11.6229 9.35317 11.4363 9.25973Z" />
                </svg>

                0853 1111 101
              </a>
              <p className='section-title'>
                <strong>Keamanan</strong>
              </p>

              <img
                src="/static/images/logo/iso-27001-lifepal.webp"
                alt="ISO 27001 Certification"
                width={96}
                height={96}
                className='mb-2000'
                loading='lazy'
                fetchPriority='low'
              />

              <p className='section-title'>
                <strong>Metode Pembayaran &amp; Program Cicilan 0%</strong>
              </p>

              <div className='d-flex flex-wrap flex-gap-0750 mb-2000'>
                <div className="payment-box">
                  <img
                    src='/static/images/logo/virtual-account.svg'
                    alt='virtual account'
                    width={48}
                    height={22}
                    loading='lazy'
                    fetchPriority='low'
                  />
                </div>

                <div className="payment-box">
                  <img
                    src='/static/images/logo/visa.svg'
                    alt='Visa'
                    width={49}
                    height={16}
                    loading='lazy'
                    fetchPriority='low'
                  />
                </div>

                <div className="payment-box">
                  <img
                    src='/static/images/logo/mastercard.svg'
                    alt='Mastercard'
                    width={45}
                    height={28}
                    loading='lazy'
                    fetchPriority='low'
                  />
                </div>

                <div className="payment-box">
                  <img
                    src='/static/images/logo/jcb.svg'
                    alt='JCB'
                    width={47}
                    height={36}
                    loading='lazy'
                    fetchPriority='low'
                  />
                </div>

                <div className="payment-box">
                  <img
                    src='/static/images/logo/gopay.svg'
                    alt='Gopay'
                    width={47}
                    height={10}
                    loading='lazy'
                    fetchPriority='low'
                  />
                </div>

                <div className="payment-box">
                  <img
                    src='/static/images/logo/indomaret.svg'
                    alt='Indomaret'
                    width={49}
                    height={16}
                    loading='lazy'
                    fetchPriority='low'
                  />
                </div>

                <div className="payment-box">
                  <img
                    src='/static/images/logo/alfamart.svg'
                    alt='Alfamart'
                    width={50}
                    height={16}
                    loading='lazy'
                    fetchPriority='low'
                  />
                </div>
              </div>

              <p className='section-title'>
                <strong>Berizin dan diawasi OJK</strong>
              </p>

              <img
                src='/static/images/logo/ojk.svg'
                className='mb-2000'
                alt='OJK'
                width={102}
                height={41}
                loading='lazy'
                fetchPriority='low'
              />
            </div>
          </div>
        </div>
      </section>

      <section className='section bottom'>
        <div className="container">
          <div className="row">
            <div className="bottom-col-one">
              <ul className='bottom-navigation'>
                <li className='mb-0'>
                  <a
                    href={`/ketentuan`}
                  >
                    Syarat &amp; Ketentuan
                  </a>
                </li>

                <li>
                  <a
                    href={`/privasi`}
                  >
                    Kebijakan Privasi
                  </a>
                </li>
              </ul>
            </div>

            <div className="bottom-col-two">
              <p className='copyright'>Copyright &copy; 2026 Lifepal -- Dikelola oleh PT Abisatya Pialang Asuransi, Pialang Asuransi Digital berizin S-463/PD.113/2025, diawasi oleh OJK sesuai KEP-018/KMK.17/1992 dan anggota 060-2001/APPARINDO/2025. Lifepal berusaha untuk menyajikan informasi yang akurat dan terbaru namun dapat berbeda dari informasi yang diberikan oleh penyedia layanan / institusi keuangan. Keseluruhan informasi diberikan tanpa jaminan, kami menyarankan untuk melakukan verifikasi sebelum melakukan keputusan finansial Anda.</p>
            </div>
          </div>
        </div>
      </section>
    </footer>
  )
}

export default Footer;